import { EventInput } from '@fullcalendar/common';
import moment from 'moment';
import React from 'react';

import FullCalendar from '@legacy-components/forms/fields/FullCalendar';

type DaysPickerInputProps = {
  days: string[];
  value: string[];
  events: { title: string; start: Date; end: Date; className?: string }[] & EventInput;
  onChange: (days: string[]) => void;
};

export default function DaysPickerInput({ days, events, value, onChange }: DaysPickerInputProps) {
  function dayRender(date: any, cell: any) {
    if (value.indexOf(date.format('YYYY-MM-DD')) > -1) {
      cell.css('background-color', '#34bfa3');
      cell.css('textColor', '#ffffff');
    } else if (days && days.indexOf(date.format('YYYY-MM-DD')) > -1) {
      cell.css('background-color', '#d6f2ed');
      cell.css('textColor', '#ffffff');
    } else {
      cell.css('background-color', '#f4f3f4');
      cell.css('cursor', 'not-allowed');
    }
  }

  function handleDateSelection(startObj: any, endObj: any) {
    const diff = endObj.diff(startObj, 'days');

    for (let i = 0; i < diff; i++) {
      let start = moment(startObj);
      const datestring = start.add(i, 'days').format('YYYY-MM-DD');
      const index = value.indexOf(datestring);
      if (days && days.indexOf(datestring) > -1) {
        if (index === -1) {
          value.push(datestring);
        } else {
          value.splice(index, 1);
        }
      }
    }

    onChange(value);
  }

  return (
    <FullCalendar
      selectable
      middle={days.length > 0 ? moment(days[0]) : undefined}
      handleSelect={handleDateSelection}
      dayRender={dayRender}
      events={events}
    />
  );
}
